module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/people_with_interaction-6b91abd3dd9357e22ab851cda9d4f0b0.svg";